export { SvgAccount } from './account';
export { SvgAccountCircle } from './account-circle';
export { SvgActionItem } from './actionItem';
export { SvgAdd } from './add';
export { SvgAddCircleOutline } from './add-circle-outline';
export { SvgAddPhoto } from './add-photo';
export { SvgAdmin } from './admin';
export { SvgAiGenerativeAudio } from './ai-generative-audio';
export { SvgAlertTriangle } from './alert-triangle';
export { SvgAlignCenter } from './align-center';
export { SvgAlignLeft } from './align-left';
export { SvgAlignRight } from './align-right';
export { SvgApple } from './apple';
export { SvgArchive } from './archive';
export { SvgArrowBack } from './arrow-back';
export { SvgArrowDownward } from './arrow-downward';
export { SvgArrowDropDown } from './arrow-drop-down';
export { SvgArrowForward } from './arrow-forward';
export { SvgArrowLeft } from './arrow-left';
export { SvgArrowRight } from './arrow-right';
export { SvgArrowSlanted } from './arrow-slanted';
export { SvgArrowUpward } from './arrow-upward';
export { SvgAtlassian } from './atlassian';
export { SvgAtMention } from './at-mention';
export { SvgAutoChapters } from './auto-chapters';
export { SvgAutoDraft } from './auto-draft';
export { SvgAutoSummaries } from './auto-summaries';
export { SvgAutoTitles } from './auto-titles';
export { SvgBack5 } from './back5';
export { SvgBannerVectorUp } from './banner-vector-up';
export { SvgBarChart } from './bar-chart';
export { SvgBell } from './bell';
export { SvgBellOff } from './bell-off';
export { SvgBlur } from './blur';
export { SvgBold } from './bold';
export { SvgBook } from './book';
export { SvgBug } from './bug';
export { SvgBulb } from './bulb';
export { SvgCalendly } from './calendly';
export { SvgCalendar } from './calendar';
export { SvgCallToAction } from './call-to-action';
export { SvgCamera } from './camera';
export { SvgCamBubble } from './cam-bubble';
export { SvgCamBubbleSmall } from './cam-bubble-small';
export { SvgCanvas } from './canvas';
export { SvgCaptions } from './captions';
export { SvgCCOff } from './cc-off';
export { SvgCCOn } from './cc-on';
export { SvgChart } from './chart';
export { SvgCheck } from './check';
export { SvgCheckCircle } from './check-circle';
export { SvgCheckCircleFill } from './check-circle-fill';
export { SvgCheckCircleSmall } from './check-circle-small';
export { SvgCheckCircleUnchecked } from './check-circle-unchecked';
export { SvgChevronDown } from './chevron-down';
export { SvgChevronLeft } from './chevron-left';
export { SvgChevronRight } from './chevron-right';
export { SvgChevronsLeft } from './chevrons-left';
export { SvgChevronSmallUp } from './chevron-small-up';
export { SvgChevronsRight } from './chevrons-right';
export { SvgChevronUp } from './chevron-up';
export { SvgChrome } from './chrome';
export { SvgChromeLogo } from './chrome-logo';
export { SvgClip } from './clip';
export { SvgClock } from './clock';
export { SvgClose } from './close';
export { SvgCode } from './code';
export { SvgCollapseReplies } from './collapse-replies';
export { SvgColorNone } from './color-none';
export { SvgComment } from './comment';
export { SvgCommentAdd } from './comment-add';
export { SvgConfetti } from './confetti';
export { SvgConfluence } from './confluence';
export { SvgConfluenceInverse } from './confluence-inverse';
export { SvgConfluenceNeutral } from './confluence-neutral';
export { SvgCopy } from './copy';
export { SvgCopyPlus } from './copy-plus';
export { SvgCreate } from './create';
export { SvgCreateTicket } from './create-ticket';
export { SvgCrop169 } from './crop-16-9';
export { SvgCropTool } from './crop-tool';
export { SvgCursor } from './cursor';
export { SvgDelete } from './delete';
export { SvgDesktopMac } from './desktop-mac';
export { SvgDevices } from './devices';
export { SvgDiagramSymbolDecision } from './diagram-symbol-decision';
export { SvgDomain } from './domain';
export { SvgDownload } from './download';
export { SvgEdgeLogo } from './edge-logo';
export { SvgEdit } from './edit';
export { SvgEditions } from './editions';
export { SvgEditBorder } from './edit-border';
export { SvgExpandReplies } from './expand-replies';
export { SvgExtension } from './extension';
export { SvgExternalLink } from './external-link';
export { SvgEye } from './eye';
export { SvgEyeOff } from './eye-off';
export { SvgFacebook } from './facebook';
export { SvgFiberManualRecord } from './fiber-manual-record';
export { SvgFillerWordRemoval } from './filler-word-removal';
export { SvgFirefoxLogo } from './firefox-logo';
export { SvgFolder } from './folder';
export { SvgFolderShared } from './folder-shared';
export { SvgForward5 } from './forward5';
export { SvgFullscreen } from './fullscreen';
export { SvgFullScreen2 } from './full-screen';
export { SvgGlobe } from './globe';
export { SvgGoogle } from './google';
export { SvgGoogleCalendarLogo } from './google-calendar-logo';
export { SvgGrid } from './grid';
export { SvgHelp } from './help';
export { SvgHelpCircle } from './help-circle';
export { SvgHighlightText } from './highlight-text';
export { SvgHome } from './home';
export { SvgImage } from './image';
export { SvgImageInline } from './image-inline';
export { SvgImageStrikethrough } from './image-strikethrough';
export { SvgImage1 } from './image1';
export { SvgImport } from './import';
export { SvgInfo } from './info';
export { SvgInfoFill } from './info-fill';
export { SvgItalics } from './italics';
export { SvgAirtable } from './airtable';
export { SvgBitbucket } from './bitbucket';
export { SvgCoda } from './coda';
export { SvgFigma } from './figma';
export { SvgGithub } from './github';
export { SvgGoogleDocs } from './google_docs';
export { SvgGoogleSheets } from './google_sheets';
export { SvgGoogleSlides } from './google_slides';
export { SvgNotion } from './notion';
export { SvgMicrosoftExcel } from './microsoft_excel';
export { SvgMicrosoftOneNote } from './microsoft_one_note';
export { SvgMicrosoftWord } from './microsoft_word';
export { SvgMicrosoftPowerpoint } from './microsoft_powerpoint';
export { SvgLucidchart } from './lucidchart';
export { SvgJira } from './jira';
export { SvgJiraNeutral } from './jira-neutral';
export { SvgLaunch } from './launch';
export { SvgLinearDark } from './linearDark';
export { SvgLineThickness } from './line-thickness';
export { SvgLink } from './link';
export { SvgLinkBroken } from './link-broken';
export { SvgLinkedIn } from './linkedin';
export { SvgLinkOff } from './link-off';
export { SvgList } from './list';
export { SvgLock } from './lock';
export { SvgLockFill } from './lock-fill';
export { SvgLockUnlocked } from './lock-unlocked';
export { SvgLogOut } from './log-out';
export { SvgMail } from './mail';
export { SvgMaximize } from './maximize';
export { SvgMenu } from './menu';
export { SvgMenuHide } from './menu-hide';
export { SvgMenuShow } from './menu-show';
export { SvgMegaphone } from './megaphone';
export { SvgMic } from './mic';
export { SvgMicOff } from './mic-off';
export { SvgMicrosoftTeamsLogo } from './microsoft-teams-logo';
export { SvgMinimize } from './minimize';
export { SvgMinus } from './minus';
export { SvgMinusCircle } from './minus-circle';
export { SvgMobileDevices } from './mobile-devices';
export { SvgMoney } from './money';
export { SvgMoon } from './moon';
export { SvgMoreHoriz } from './more-horiz';
export { SvgMute } from './mute';
export { SvgNotes } from './notes';
export { SvgNumberedList } from './numbered-list';
export { SvgOutlook } from './outlook';
export { SvgOverlays } from './overlays';
export { SvgPaintBucket } from './paint-bucket';
export { SvgPalette } from './palette';
export { SvgPause } from './pause';
export { SvgPictureInPicture } from './picture-in-picture';
export { SvgPin } from './pin';
export { SvgPinFill } from './pin-fill';
export { SvgPlay } from './play';
export { SvgPlayCircle } from './play-circle';
export { SvgPlusCircle } from './plus-circle';
export { SvgPlaylist } from './playlist';
export { SvgPower } from './power';
export { SvgPresent } from './present';
export { SvgPresenterMode } from './presenter-mode';
export { SvgPronunciation } from './pronunciation';
export { SvgPublicOff } from './public-off';
export { SvgPublicOn } from './public-on';
export { SvgPullRequest } from './pull-request';
export { SvgQuickEdit } from './quick-edit';
export { SvgRecord } from './record';
export { SvgRedoAlt } from './redo-alt';
export { SvgRefresh } from './refresh';
export { SvgRepeat } from './repeat';
export { SvgReplay } from './replay';
export { SvgReply } from './reply';
export { SvgReplyLeft } from './reply-left';
export { SvgReplyRight } from './reply-right';
export { SvgRewind } from './rewind';
export { SvgRovo } from './rovo';
export { SvgSafariLogo } from './safari-logo';
export { SvgSalesforce } from './salesforce';
export { SvgSalesforceBlk } from './salesforce-blk';
export { SvgSchool } from './school';
export { SvgScissors } from './scissors';
export { SvgScreenCam } from './screen-cam';
export { SvgSearch } from './search';
export { SvgSend } from './send';
export { SvgSettings } from './settings';
export { SvgShapeEllipse } from './shape-ellipse';
export { SvgSilenceRemoval } from './silence-removal';
export { SvgSkipBack } from './skip-back';
export { SvgSlack } from './slack';
export { SvgSmile } from './smile';
export { SvgSmileSelect } from './smile-select';
export { SvgSquare } from './square';
export { SvgSpaces } from './spaces';
export { SvgSparkle } from './sparkle';
export { SvgSpeedFast } from './speed-fast';
export { SvgSpeedMedium } from './speed-medium';
export { SvgSpeedSlow } from './speed-slow';
export { SvgSplit } from './split';
export { SvgStar } from './star';
export { SvgStarOutline } from './star-outline';
export { SvgStop } from './stop';
export { SvgSuggestedEdit } from './suggested-edit';
export { SvgSun } from './sun';
export { SvgTask } from './task';
export { SvgTeamworkAgentBig } from './teamwork-agent-big';
export { SvgTeamworkAgentSmall } from './teamwork-agent-small';
export { SvgTeamworkGraph } from './teamwork-graph';
export { SvgText } from './text';
export { SvgTextRephrase } from './text-rephrase';
export { SvgThumbsDown } from './thumbs-down';
export { SvgThumbsUp } from './thumbs-up';
export { SvgTimelineEditor } from './timeline-editor';
export { SvgTimer } from './timer';
export { SvgTranscript } from './transcript';
export { SvgTrash } from './trash';
export { SvgTrelloNeutral } from './trello-neutral';
export { SvgTrello } from './trello';
export { SvgTune } from './tune';
export { SvgUnderline } from './underline';
export { SvgUndoAlt } from './undo-alt';
export { SvgUpload } from './upload';
export { SvgUser } from './user';
export { SvgUsers } from './users';
export { SvgUsersAdd } from './users-add';
export { SvgVariables } from './variables';
export { SvgVersionControl } from './version-control';
export { SvgVideoCam } from './video-cam';
export { SvgVideocam } from './videocam';
export { SvgVideoLibrary } from './video-library';
export { SvgVideoOff } from './video-off';
export { SvgVolume1 } from './volume1';
export { SvgVolume2 } from './volume2';
export { SvgVolumeX } from './volume-x';
export { SvgWarningAlert } from './warning-alert';
export { SvgWatchLater } from './watch-later';
export { SvgWatchLaterAdded } from './watch-later-added';
export { SvgWatchLaterRemove } from './watch-later-remove';
export { SvgWaveform } from './waveform';
export { SvgWindow } from './window';
export { SvgWindows } from './windows';
export { SvgWriteDocument } from './write-document';
export { SvgWriteMessage } from './write-message';
export { SvgXCircle } from './x-circle';
export { SvgXLogo } from './x-twitter';
export { SvgZapOutline } from './zap-outline';
export { SvgZoomIn } from './zoom-in';
export { SvgZoomLogo } from './zoom-logo';
export { SvgZoomOut } from './zoom-out';
